import { render, staticRenderFns } from "./ShowcaseDetail.vue?vue&type=template&id=65e31ad2&"
import script from "./ShowcaseDetail.vue?vue&type=script&lang=js&"
export * from "./ShowcaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShowcaseDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports